"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBreakpoint = void 0;
var react_1 = require("react");
var events_1 = __importDefault(require("events"));
var defaultBreakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
};
var getBreakpoint = function (breakpoints) {
    var _a;
    var sizes = ["xxl", "xl", "lg", "md", "sm", "xs"];
    return (_a = sizes.find(function (s) { var _a; return window.innerWidth >= ((_a = breakpoints[s]) !== null && _a !== void 0 ? _a : 0); })) !== null && _a !== void 0 ? _a : "xs";
};
var emitter = new events_1.default();
window.addEventListener("resize", function () { return emitter.emit("resize"); });
var useBreakpoint = function (breakpoints) {
    if (breakpoints === void 0) { breakpoints = defaultBreakpoints; }
    var _a = __read((0, react_1.useState)("xs"), 2), breakpoint = _a[0], setBreakpoint = _a[1];
    (0, react_1.useLayoutEffect)(function () {
        var updateWidth = function () { return setBreakpoint(getBreakpoint(breakpoints)); };
        updateWidth();
        emitter.on("resize", updateWidth);
        return function () { emitter.off("resize", updateWidth); };
    }, []);
    var valueAtSize = function (values) {
        var _a;
        var allSizes = ["xxl", "xl", "lg", "md", "sm", "xs"];
        var breakpointIndex = allSizes.indexOf(breakpoint);
        var remaining = allSizes.slice(breakpointIndex);
        return values[(_a = remaining.find(function (s) { return values[s] !== undefined; })) !== null && _a !== void 0 ? _a : "xs"];
    };
    return valueAtSize;
};
exports.useBreakpoint = useBreakpoint;
